import { render, staticRenderFns } from "./Freelance.vue?vue&type=template&id=13607e66&scoped=true&"
import script from "./Freelance.vue?vue&type=script&lang=js&"
export * from "./Freelance.vue?vue&type=script&lang=js&"
import style0 from "./Freelance.vue?vue&type=style&index=0&id=13607e66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13607e66",
  null
  
)

export default component.exports